import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";

import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import Grid from "@mui/material/Grid";

import Stack from "@mui/material/Stack";
import CardHeader from "@mui/material/CardHeader";
import {
  CircularProgress,
  Divider,
  IconButton,
  Tab,
  Tabs,
  TextField,
  List,
  ListItem,
  ListItemIcon,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DialogActions from "@mui/material/DialogActions";
import { listNftByAuctionId } from "services/apiService";
import { useLocation, useSearchParams } from "react-router-dom";
import MDBox from "components/MDBox";

import MDAvatar from "components/MDAvatar";
import TabPanel from "components/TabPanel";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { getBidList } from "services/apiService";
import { getSoldList } from "services/apiService";
import { buyNft } from "services/contractService";
import { postBuyNft } from "services/apiService";
import { bidNft } from "services/contractService";
import { postBidNft } from "services/apiService";
import { acceptBidNft } from "services/contractService";
import { postAcceptBidNft } from "services/apiService";
import { deleteBid } from "services/apiService";
import singhCoinCurrency from "assets/images/singhCoinCurrency.png";
import validations from "customValidations/validations";
import validationService from "customValidations/validationService";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SpinLoader from "components/SpinLoader";
import MintDialog from "layouts/dialogModals/mintDialog";
import { borderRadius } from "@mui/system";
import SubjectIcon from "@mui/icons-material/Subject";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Grid4x4Icon from "@mui/icons-material/Grid4x4";
import NfcIcon from "@mui/icons-material/Nfc";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import Moment from "react-moment";
import moment from "moment";
import { postUnLike } from "services/apiService";
import { postLike } from "services/apiService";
import LikesDialog from "layouts/dialogModals/LikesDialog";
import CommentsDialog from "layouts/dialogModals/CommentDialog";
import { checkBidderWalletBal } from "services/apiService";
import {
  singhCoinAddress,
  nftContractAddress,
  nftMarketPlaceAddress,
} from "utils/config";
import { web3Instance } from "Store/slices/walletSlice";
import { useDispatch, useSelector } from "react-redux";
import { loginDialogReducer } from "Store/slices/loginDialogSlice";

export default function AuctionDetails() {
  const web3 = web3Instance();

  let navigate = useNavigate();

  const dispatch = useDispatch();

  const { userAuthInfo, loginStatus, isLoadingAuth } = useSelector(
    (state) => state.userAuth
  );

  const {
    isWeb3Enabled,
    address,
    chainId,
    balance,
    reward,
    isWalletLoading,
    isRewardLoading,
  } = useSelector((state) => state.walletData);

  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [tabValue, setTabValue] = useState(0);
  const [auctionData, setAuctionData] = useState("");

  const [bidPrice, setBidPrice] = useState("");
  const [bidderList, setBidderList] = useState([]);
  const [soldList, setSoldList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [btnLoader, setBtnLoader] = useState(false);
  const [acceptBtnLoader, setAcceptBtnLoader] = useState([]);
  const [cancelBtnLoader, setCancelBtnLoader] = useState([]);
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const [errorMsg, setErrorMsg] = useState({
    bidPrice: { errorMsg: "" },
  });

  const [externalValidation, setExternalValidation] = useState(false);
  const [mintDialogBoolean, setMintDialogBoolean] = useState(false);
  const [mintNftData, setMintNftData] = useState("");
  const [changePriceBoolean, setChangePriceBoolean] = useState(false);
  const [likeDialogBoolean, setLikeDialogBoolean] = useState(false);
  const [commentDialogBoolean, setCommentDialogBoolean] = useState(false);
  const [postId, setPostId] = useState("");
  const [refresher, setRefresher] = useState(false);
  const [highestBid, setHighestBid] = useState(0);

  useEffect(() => {
    fetchListNftByAuctionId();
  }, [refresher]);

  // console.log("location", auctionData);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  // let date;

  const fetchListNftByAuctionId = async () => {
    setLoading(true);
    const listNftByAuctionIdRes = await listNftByAuctionId(
      searchParams.get("auctionId")
    );
    // console.log("listNftByAuctionIdRes", listNftByAuctionIdRes);
    setAuctionData(listNftByAuctionIdRes[0]);

    const getBidListRes = await getBidList(searchParams.get("auctionId"));
    // console.log("getBidListRes", getBidListRes);
    setBidderList(getBidListRes);
    setAcceptBtnLoader(Array(getBidListRes.length).fill(false));
    setCancelBtnLoader(Array(getBidListRes.length).fill(false));

    if (getBidListRes.length > 0) {
      let maxBid = [];

      for (let item of getBidListRes) {
        maxBid.push(item.price);
      }
      setHighestBid(Math.max(...maxBid));
    }

    const getSoldListRes = await getSoldList(searchParams.get("auctionId"));
    // console.log("getSoldListRes", getSoldListRes);
    setSoldList(getSoldListRes);

    setLoading(false);
  };

  const customValidations = (name, value) => {
    let errorLength = 0;
    const args = [
      {
        name,
        value: value,
        validations: validations.marketPlaceValidations[name],
      },
    ];

    validationService.validate(args, (validationErr, validationErrMsgs) => {
      if (validationErrMsgs.length > 0) {
        errorLength = errorLength + 1;
        errorMsg[name].errorMsg = validationErrMsgs[0].validations[0].message;
        setErrorMsg({ ...errorMsg });
      } else {
        errorMsg[name].errorMsg = "";
        setErrorMsg({ ...errorMsg });
      }
    });
    return errorLength;
  };

  const handleBuyFixedPrice = async () => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    if (!isWeb3Enabled) {
      // console.log("pls connect wallet");
      // Swal.fire("", "Please connect your Metamask Wallet");
      toast.warning(`Please connect your Metamask Wallet`, {
        style: {
          fontSize: "12px",
        },
      });
      return;
    }

    if (balance < auctionData.price) {
      // console.log("pls connect wallet");
      // Swal.fire("", "Please connect your Metamask Wallet");
      toast.warning(`Insufficient wallet balance`, {
        style: {
          fontSize: "12px",
        },
      });
      return;
    }

    setBtnLoader(true);

    const buyNftRes = await buyNft(
      web3,
      address,
      auctionData.tokenID,
      auctionData.price
    );
    // console.log("buyNftRes", buyNftRes);

    if (buyNftRes.transactionHash) {
      const buyData = {
        auctionID: auctionData._id,
        address: address,
      };

      const boughtNftRes = await postBuyNft(buyData);
      // console.log("boughtNftRes", boughtNftRes);
      if (boughtNftRes.status === 200) {
        toast.success(`Bought nft successfully`, {
          style: {
            fontSize: "12px",
          },
        });
        setBtnLoader(false);
        setRefresher((prev) => !prev);
      } else {
        toast.error(`Something went wrong, Please try again later`, {
          style: {
            fontSize: "12px",
          },
        });
        setBtnLoader(false);
      }
    } else {
      toast.error(`Contract failed`, {
        style: {
          fontSize: "12px",
        },
      });
      setBtnLoader(false);
    }
  };

  const handleBuyForBid = async () => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    let errorLengthBidPrice = customValidations("bidPrice", bidPrice);

    if (errorLengthBidPrice === 1) {
      return;
    }

    if (!isWeb3Enabled) {
      toast.warning(`Please connect your Metamask Wallet`, {
        style: {
          fontSize: "12px",
        },
      });
      return;
    }

    if (
      Number(balance) < auctionData.price ||
      Number(balance) < Number(bidPrice)
    ) {
      // console.log("pls connect wallet");
      // Swal.fire("", "Please connect your Metamask Wallet");
      toast.warning(`Insufficient wallet balance`, {
        style: {
          fontSize: "12px",
        },
      });
      return;
    }

    if (Number(bidPrice) < auctionData.price) {
      setExternalValidation(true);
      setBtnLoader(false);
      return;
    }
    setBtnLoader(true);

    const forBidNftRes = await bidNft(web3, address, bidPrice);
    // console.log("forBidNftRes", forBidNftRes);

    if (forBidNftRes.transactionHash) {
      const bidData = {
        auctionID: auctionData._id,
        bidPrice: bidPrice,
      };

      const bidNftRes = await postBidNft(bidData);
      // console.log(" bidNftRes", bidNftRes);

      if (bidNftRes.status === 200) {
        toast.success(`Bid placed`, {
          style: {
            fontSize: "12px",
          },
        });
        setBtnLoader(false);
        setBidPrice("");
        setRefresher((prev) => !prev);
      } else {
        toast.error(`Something went wrong, please try again`, {
          style: {
            fontSize: "12px",
          },
        });
        setBtnLoader(false);
      }
    } else {
      toast.error(`Contract failed`, {
        style: {
          fontSize: "12px",
        },
      });
      setBtnLoader(false);
    }
  };

  const handleChangeInput = (value) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setBidPrice(value);
  };

  const handleAcceptBid = async (bidderAddress, price, bidId, idx) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    if (!isWeb3Enabled) {
      toast.warning(`Please connect your Metamask Wallet`, {
        style: {
          fontSize: "12px",
        },
      });
      return;
    }

    setAcceptBtnLoader((prevState) => {
      const newState = [...prevState];
      newState[idx] = true;
      return newState;
    });

    const checkBidderWalletBalRes = await checkBidderWalletBal(bidderAddress);

    if (checkBidderWalletBalRes.status === 200) {
      const singhCoin = checkBidderWalletBalRes.data["Singh Coin"];
      if (Number(singhCoin) < price) {
        toast.warning(
          `Bidder dont have enough balance in his wallet, Please select another bidder`,
          {
            style: {
              fontSize: "12px",
            },
          }
        );
        setAcceptBtnLoader((prevState) => {
          const newState = [...prevState];
          newState[idx] = false;
          return newState;
        });
        return;
      } else {
        const bidAcceptedRes = await acceptBidNft(
          web3,
          address,
          auctionData.tokenID,
          price,
          bidderAddress
        );

        // console.log("bidAcceptedRes", bidAcceptedRes);
        if (bidAcceptedRes.transactionHash) {
          const bidderData = {
            auctionID: auctionData._id,
            bidId: bidId,
            bidAddress: bidderAddress,
          };
          const acceptBidRes = await postAcceptBidNft(bidderData);
          // console.log("acceptBidRes", acceptBidRes);

          if (acceptBidRes.status === 200) {
            toast.success(`Bid accepted`, {
              style: {
                fontSize: "12px",
              },
            });
            setRefresher((prev) => !prev);
            setAcceptBtnLoader((prevState) => {
              const newState = [...prevState];
              newState[idx] = false;
              return newState;
            });
            return;
          } else {
            toast.error(
              `Something went wrong with server, Please try again later`,
              {
                style: {
                  fontSize: "12px",
                },
              }
            );
            setAcceptBtnLoader((prevState) => {
              const newState = [...prevState];
              newState[idx] = false;
              return newState;
            });
            return;
          }
        } else {
          toast.error(`Contract failed`, {
            style: {
              fontSize: "12px",
            },
          });
          setAcceptBtnLoader((prevState) => {
            const newState = [...prevState];
            newState[idx] = false;
            return newState;
          });
          return;
        }
      }
    } else {
      toast.error(
        `Cannot fetch bidder wallet balance at present, Please try again later`,
        {
          style: {
            fontSize: "12px",
          },
        }
      );

      setAcceptBtnLoader((prevState) => {
        const newState = [...prevState];
        newState[idx] = false;
        return newState;
      });
      return;
    }
  };

  const handleCancelBid = async (bidderId, idx) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setCancelBtnLoader((prevState) => {
      const newState = [...prevState];
      newState[idx] = true;
      return newState;
    });

    const deleteData = {
      auctionID: auctionData._id,
      bidId: bidderId,
    };

    const cancelBidRes = await deleteBid(deleteData);
    // console.log("cancelBidRes", cancelBidRes);

    if (cancelBidRes.status === 200) {
      toast.success(`Bid cancelled`, {
        style: {
          fontSize: "12px",
        },
      });
      setRefresher((prev) => !prev);
      setCancelBtnLoader((prevState) => {
        const newState = [...prevState];
        newState[idx] = false;
        return newState;
      });
    } else {
      toast.error(`Something went wrong, Please try again later`, {
        style: {
          fontSize: "12px",
        },
      });
      setCancelBtnLoader((prevState) => {
        const newState = [...prevState];
        newState[idx] = false;
        return newState;
      });
    }
  };

  const handleOpenMintDialog = () => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    if (!isWeb3Enabled) {
      // console.log("pls connect wallet");
      // Swal.fire("", "Please connect your Metamask Wallet");
      toast.warning(`Please connect your Metamask Wallet`, {
        style: {
          fontSize: "12px",
        },
      });
      return;
    }
    setMintNftData(auctionData);
    setMintDialogBoolean(true);
  };

  const handleCloseMintDialog = () => {
    setMintDialogBoolean(false);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleLikeUnLike = async (isLikedBoolean, postId, nftId) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    const postID = {
      postID: postId,
    };

    // console.log("postId", postId);
    // console.log("nftId", nftId);

    if (isLikedBoolean) {
      const postUnlikeRes = await postUnLike(postID);
      // console.log("postUnLikeRes", postUnlikeRes);

      const nftByIdRes = await listNftByAuctionId(nftId);
      // console.log("nftByIdRes", nftByIdRes);
      setAuctionData(nftByIdRes[0]);
    } else {
      const postLikeRes = await postLike(postID);
      //  console.log("postLikeRes", postLikeRes);

      const nftByIdRes = await listNftByAuctionId(nftId);
      // console.log("nftByIdRes", nftByIdRes);
      setAuctionData(nftByIdRes[0]);
    }
  };

  const openLikesDialog = (value) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setPostId(value);
    setLikeDialogBoolean(true);
  };

  const handleCloseLikeDialog = () => {
    setLikeDialogBoolean(false);
  };

  const openCommentsDialog = (value) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setPostId(value);
    setCommentDialogBoolean(true);
  };

  const handleCloseCommentDialog = () => {
    setCommentDialogBoolean(false);
  };

  const handleUsernameClick = (username) => {
    navigate(`/profile/?username=${username}`);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        {loading ? (
          <MDBox
            sx={{
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <SpinLoader />
          </MDBox>
        ) : (
          <>
            <Card sx={{ marginTop: "1rem", padding: "0.5rem" }}>
              <Grid container spacing={3}>
                <Grid item container xs={12} md={5.5}>
                  <MDBox
                    sx={{
                      width: "100%",
                      height: "420px",
                    }}
                  >
                    <img
                      src={auctionData.postDetails.photo}
                      height="100%"
                      width="100%"
                      style={{
                        border: "1px solid #343434",
                        borderRadius: "10px",
                        objectFit: "cover",
                      }}
                    />
                  </MDBox>
                </Grid>
                <Grid item container xs={12} md={6.5}>
                  <MDBox sx={{ width: "100%" }}>
                    <MDBox sx={{ width: "100%" }}>
                      <CardHeader
                        avatar={
                          <MDAvatar
                            sx={{
                              width: "3.5rem",
                              height: "3.5rem",
                              cursor: "pointer",
                            }}
                            src={auctionData.userDetails.pic}
                            imgProps={{
                              style: { height: "100%", width: "100%" },
                            }}
                            onClick={() =>
                              handleUsernameClick(
                                auctionData.userDetails.username
                              )
                            }
                          />
                        }
                        title={
                          <MDTypography
                            sx={{
                              fontSize: "22px",
                              fontWeight: "700",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              handleUsernameClick(
                                auctionData.userDetails.username
                              )
                            }
                          >
                            {auctionData.name}
                          </MDTypography>
                        }
                        subheader={
                          <MDTypography
                            fontSize="14px"
                            sx={{ color: "#BDAAC1", cursor: "pointer" }}
                            onClick={() =>
                              handleUsernameClick(
                                auctionData.userDetails.username
                              )
                            }
                          >
                            by @{auctionData.userDetails.username}
                          </MDTypography>
                        }
                      />
                    </MDBox>
                    <MDBox
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        marginBottom: "1rem",
                      }}
                    >
                      <CardActions disableSpacing sx={{ padding: "20px" }}>
                        <MDBox sx={{ display: "flex", alignItems: "center" }}>
                          <IconButton
                            onClick={() =>
                              handleLikeUnLike(
                                auctionData.postDetails.isLiked,
                                auctionData.postDetails._id,
                                auctionData._id
                              )
                            }
                          >
                            {auctionData.postDetails.isLiked ? (
                              <FavoriteIcon style={{ color: "red" }} />
                            ) : (
                              <FavoriteBorderIcon style={{ color: "#fff" }} />
                            )}
                          </IconButton>
                          <MDTypography
                            fontWeight="bold"
                            sx={{
                              cursor: "pointer",
                              fontSize: "16px",
                              color: "#cacaca",
                            }}
                            onClick={() =>
                              openLikesDialog(auctionData.postDetails._id)
                            }
                          >
                            {auctionData.postDetails.totalLike} Likes
                          </MDTypography>
                        </MDBox>
                        &nbsp;&nbsp;
                        <MDBox sx={{ display: "flex", alignItems: "center" }}>
                          <IconButton
                            onClick={() =>
                              openCommentsDialog(auctionData.postDetails._id)
                            }
                          >
                            <ChatBubbleOutlineIcon
                              style={{ color: "#cacaca" }}
                            />
                          </IconButton>
                          <MDTypography
                            fontWeight="bold"
                            sx={{
                              cursor: "pointer",
                              fontSize: "16px",
                              color: "#cacaca",
                            }}
                            onClick={() =>
                              openCommentsDialog(auctionData.postDetails._id)
                            }
                          >
                            {auctionData.postDetails.totalComment} Comments
                          </MDTypography>
                        </MDBox>
                      </CardActions>

                      <Card
                        sx={{
                          // minWidth: 400,
                          width: "100%",
                          backgroundColor: "#062330",
                          marginTop: "15px",
                        }}
                      >
                        <CardContent>
                          {auctionData.sellingStatus === "Time Auction" && (
                            <>
                              <MDBox>
                                <MDTypography
                                  sx={{ fontSize: "16px" }}
                                  component="div"
                                >
                                  Sale ends{" "}
                                  <Moment format="MMMM D, YYYY [at] h:mm A">
                                    {/* {date} */}
                                    {moment
                                      .utc(auctionData.endDateTimeAuction)
                                      .local()
                                      .startOf("day")
                                      .format()}
                                  </Moment>
                                </MDTypography>
                              </MDBox>
                              <Divider />
                            </>
                          )}

                          <MDBox
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <MDBox
                              sx={{
                                width: "150px",
                                textAlign: "center",
                              }}
                            >
                              <MDBox>
                                <MDTypography
                                  sx={{ fontSize: "15px", color: "#BDAAC1" }}
                                >
                                  {auctionData.sellingStatus === "For sale"
                                    ? "Current price"
                                    : auctionData.sellingStatus ===
                                      "Not for sale"
                                    ? "Current price"
                                    : "Minimum bid"}
                                </MDTypography>
                              </MDBox>
                              <MDBox
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <MDBox sx={{ height: "35px", width: "35px" }}>
                                  <img
                                    src={singhCoinCurrency}
                                    height="100%"
                                    width="100%"
                                    alt="currentSymbol"
                                  />
                                </MDBox>
                                <MDBox>
                                  <MDTypography
                                    color="white"
                                    fontWeight="bold"
                                    fontSize="30px"
                                    sx={{ marginTop: "-3px" }}
                                  >
                                    {auctionData.price}
                                  </MDTypography>
                                </MDBox>
                              </MDBox>
                            </MDBox>
                            {auctionData.sellingStatus ===
                            "Open for bidding" ? (
                              <MDBox
                                sx={{
                                  width: "150px",
                                  textAlign: "center",
                                }}
                              >
                                <MDBox>
                                  <MDTypography
                                    sx={{ fontSize: "15px", color: "#BDAAC1" }}
                                  >
                                    Highest Bid
                                  </MDTypography>
                                </MDBox>
                                <MDBox
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <MDBox sx={{ height: "35px", width: "35px" }}>
                                    <img
                                      src={singhCoinCurrency}
                                      height="100%"
                                      width="100%"
                                      alt="currentSymbol"
                                    />
                                  </MDBox>
                                  <MDBox>
                                    {highestBid === 0 ? (
                                      <MDTypography
                                        color="white"
                                        fontWeight="bold"
                                        fontSize="15px"
                                        sx={{ marginTop: "-3px" }}
                                      >
                                        No Bid
                                      </MDTypography>
                                    ) : (
                                      <MDTypography
                                        color="white"
                                        fontWeight="bold"
                                        fontSize="30px"
                                        sx={{ marginTop: "-3px" }}
                                      >
                                        {highestBid}
                                      </MDTypography>
                                    )}
                                  </MDBox>
                                </MDBox>
                              </MDBox>
                            ) : auctionData.sellingStatus === "Time Auction" ? (
                              <MDBox
                                sx={{
                                  width: "150px",
                                  textAlign: "center",
                                }}
                              >
                                <MDBox>
                                  <MDTypography
                                    sx={{ fontSize: "15px", color: "#BDAAC1" }}
                                  >
                                    Highest Bid
                                  </MDTypography>
                                </MDBox>
                                <MDBox
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <MDBox sx={{ height: "35px", width: "35px" }}>
                                    <img
                                      src={singhCoinCurrency}
                                      height="100%"
                                      width="100%"
                                      alt="currentSymbol"
                                    />
                                  </MDBox>
                                  <MDBox>
                                    {highestBid === 0 ? (
                                      <MDTypography
                                        color="white"
                                        fontWeight="bold"
                                        fontSize="15px"
                                        sx={{ marginTop: "-3px" }}
                                      >
                                        No Bid
                                      </MDTypography>
                                    ) : (
                                      <MDTypography
                                        color="white"
                                        fontWeight="bold"
                                        fontSize="30px"
                                        sx={{ marginTop: "-3px" }}
                                      >
                                        {highestBid}
                                      </MDTypography>
                                    )}
                                  </MDBox>
                                </MDBox>
                              </MDBox>
                            ) : null}
                          </MDBox>
                        </CardContent>
                        <CardActions sx={{ padding: 0 }}>
                          <MDBox sx={{ width: "100%" }}>
                            {auctionData.sellingStatus !== "Not for sale" ? (
                              auctionData.sellingStatus !== "For sale" &&
                              auctionData.userDetails.walletAddress !==
                                address ? (
                                <MDBox
                                  sx={{
                                    paddingLeft: "20px",
                                    paddingRight: "20px",
                                  }}
                                >
                                  <TextField
                                    fullWidth
                                    type="number"
                                    name="Bid price"
                                    label="Bid"
                                    error={
                                      errorMsg.bidPrice.errorMsg.length > 0 ||
                                      externalValidation
                                    }
                                    onChange={(e) =>
                                      handleChangeInput(e.target.value)
                                    }
                                    placeholder="Bid price"
                                    value={bidPrice}
                                    helperText={
                                      externalValidation
                                        ? "Bid price cannot be less than auctioned price"
                                        : errorMsg.bidPrice.errorMsg
                                    }
                                  />
                                </MDBox>
                              ) : null
                            ) : null}

                            {auctionData.userDetails.walletAddress !==
                              address && (
                              <MDBox sx={{ padding: "1rem" }}>
                                {auctionData.sellingStatus ===
                                "Not for sale" ? null : auctionData.sellingStatus ===
                                  "For sale" ? (
                                  <MDButton
                                    disabled={btnLoader}
                                    fullWidth
                                    color="singh"
                                    onClick={() => handleBuyFixedPrice()}
                                  >
                                    {btnLoader ? (
                                      <CircularProgress
                                        size={20}
                                        color="inherit"
                                      />
                                    ) : (
                                      "Buy"
                                    )}
                                  </MDButton>
                                ) : (
                                  <MDButton
                                    disabled={btnLoader}
                                    fullWidth
                                    color="singh"
                                    onClick={() => handleBuyForBid()}
                                  >
                                    {btnLoader ? (
                                      <CircularProgress
                                        size={20}
                                        color="inherit"
                                      />
                                    ) : (
                                      "Place bid"
                                    )}
                                  </MDButton>
                                )}
                              </MDBox>
                            )}

                            {auctionData.userDetails.username ===
                              localStorage.getItem("userNameSingh") && (
                              <MDBox sx={{ padding: "1rem" }}>
                                {auctionData.sellingStatus ===
                                "Not for sale" ? (
                                  <MDButton
                                    disabled={btnLoader}
                                    fullWidth
                                    color="singh"
                                    onClick={() => handleOpenMintDialog()}
                                  >
                                    {btnLoader ? (
                                      <CircularProgress
                                        size={20}
                                        color="inherit"
                                      />
                                    ) : (
                                      "Set for sale"
                                    )}
                                  </MDButton>
                                ) : null}
                              </MDBox>
                            )}
                          </MDBox>
                        </CardActions>
                      </Card>
                    </MDBox>
                  </MDBox>
                </Grid>
                <Grid item container xs={12} md={12}>
                  <Card
                    sx={{
                      width: "100%",
                      backgroundColor: "#062330",
                      marginTop: "15px",
                    }}
                  >
                    <Accordion
                      sx={{ backgroundColor: "#062330", padding: "8px 16px" }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        name="decription"
                      >
                        <MDBox sx={{ display: "flex", alignItems: "center" }}>
                          <ListItemIcon>
                            <SubjectIcon
                              fontSize="medium"
                              sx={{ color: "#fff" }}
                            />
                          </ListItemIcon>
                          <MDTypography
                            sx={{ fontSize: "18px", fontWeight: "700" }}
                          >
                            Description
                          </MDTypography>
                        </MDBox>
                      </AccordionSummary>
                      <AccordionDetails>
                        <MDBox>
                          <List sx={{ paddingLeft: "10px" }}>
                            <ListItem disablePadding>
                              <ListItemButton
                                sx={{ fontSize: "18px", color: "#cacaca" }}
                              >
                                {auctionData.description}
                                <ListItemText />
                              </ListItemButton>
                            </ListItem>
                            {/* ))} */}
                          </List>
                        </MDBox>
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      sx={{ backgroundColor: "#062330", padding: "8px 16px" }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        name="details"
                      >
                        <MDBox sx={{ display: "flex", alignItems: "center" }}>
                          <ListItemIcon>
                            <SlideshowIcon
                              fontSize="medium"
                              sx={{ color: "#fff" }}
                            />
                          </ListItemIcon>
                          <MDTypography
                            sx={{ fontSize: "18px", fontWeight: "700" }}
                          >
                            Details
                          </MDTypography>
                        </MDBox>
                      </AccordionSummary>
                      <AccordionDetails>
                        <MDBox>
                          <List sx={{ paddingLeft: "10px" }}>
                            <MDBox
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <MDBox>
                                <MDTypography
                                  sx={{ fontSize: "18px", color: "#cacaca" }}
                                >
                                  Creator :
                                </MDTypography>
                                <MDTypography
                                  sx={{ fontSize: "18px", color: "#cacaca" }}
                                >
                                  Owner :
                                </MDTypography>
                                <MDTypography
                                  sx={{ fontSize: "18px", color: "#cacaca" }}
                                >
                                  Contract address :
                                </MDTypography>
                                <MDTypography
                                  sx={{ fontSize: "18px", color: "#cacaca" }}
                                >
                                  Token Id :
                                </MDTypography>
                                <MDTypography
                                  sx={{ fontSize: "18px", color: "#cacaca" }}
                                >
                                  Token standard :
                                </MDTypography>
                                <MDTypography
                                  sx={{ fontSize: "18px", color: "#cacaca" }}
                                >
                                  Blockchain :
                                </MDTypography>
                                <MDTypography
                                  sx={{ fontSize: "18px", color: "#cacaca" }}
                                >
                                  Collector fees :
                                </MDTypography>
                              </MDBox>

                              <MDBox>
                                <MDTypography
                                  sx={{ fontSize: "18px", color: "#909090" }}
                                >
                                  {`${auctionData.createAddress.substring(
                                    0,
                                    5
                                  )}...${auctionData.createAddress.substring(
                                    auctionData.createAddress.length - 5
                                  )}`}
                                </MDTypography>
                                <MDTypography
                                  sx={{ fontSize: "18px", color: "#909090" }}
                                >
                                  {`${auctionData.userDetails.walletAddress.substring(
                                    0,
                                    5
                                  )}...${auctionData.userDetails.walletAddress.substring(
                                    auctionData.userDetails.walletAddress
                                      .length - 5
                                  )}`}
                                </MDTypography>
                                <MDTypography
                                  sx={{ fontSize: "18px", color: "#909090" }}
                                >
                                  {`${nftContractAddress.substring(
                                    0,
                                    5
                                  )}...${nftContractAddress.substring(
                                    nftContractAddress.length - 5
                                  )}`}
                                </MDTypography>
                                <MDTypography
                                  sx={{ fontSize: "18px", color: "#909090" }}
                                >
                                  {auctionData.tokenID}
                                </MDTypography>
                                <MDTypography
                                  sx={{ fontSize: "18px", color: "#909090" }}
                                >
                                  ERC721
                                </MDTypography>
                                <MDTypography
                                  sx={{ fontSize: "18px", color: "#909090" }}
                                >
                                  {auctionData.blockChain}
                                </MDTypography>
                                <MDTypography
                                  sx={{ fontSize: "16px", color: "#909090" }}
                                >
                                  {auctionData.royalties}%
                                </MDTypography>
                              </MDBox>
                            </MDBox>
                          </List>
                        </MDBox>
                      </AccordionDetails>
                    </Accordion>

                    {auctionData.sellingStatus !== "For sale" && (
                      <Accordion
                        sx={{ backgroundColor: "#062330", padding: "8px 16px" }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                          name="bid"
                        >
                          <MDBox sx={{ display: "flex", alignItems: "center" }}>
                            <ListItemIcon>
                              <Grid4x4Icon
                                fontSize="medium"
                                sx={{ color: "#fff" }}
                              />
                            </ListItemIcon>
                            <MDTypography
                              sx={{ fontSize: "18px", fontWeight: "700" }}
                            >
                              Bid
                            </MDTypography>
                          </MDBox>
                        </AccordionSummary>
                        <AccordionDetails>
                          <List>
                            <MDBox value={tabValue} index={1}>
                              {bidderList.length > 0 ? (
                                <>
                                  {bidderList.map((item, idx) => (
                                    <MDBox
                                      key={idx}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <MDBox
                                        sx={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <MDBox>
                                          <MDAvatar
                                            src={item.profilePic}
                                            imgProps={{
                                              style: {
                                                height: "100%",
                                                width: "100%",
                                              },
                                            }}
                                          />
                                        </MDBox>
                                        <MDBox>
                                          <MDTypography
                                            sx={{
                                              fontSize: "16px",
                                              marginLeft: "10px",
                                            }}
                                          >
                                            {item.price} SINGH by &nbsp;
                                            {`${item.address.substring(
                                              0,
                                              7
                                            )}...${item.address.substring(
                                              item.address.length - 5
                                            )}`}
                                          </MDTypography>
                                          <MDTypography
                                            sx={{
                                              fontSize: "14px",
                                              marginLeft: "10px",
                                              color: "#cacaca",
                                            }}
                                          >
                                            <Moment fromNow>{item.date}</Moment>
                                          </MDTypography>
                                        </MDBox>
                                      </MDBox>

                                      {auctionData.userDetails.username ===
                                      localStorage.getItem("userNameSingh") ? (
                                        <MDBox>
                                          <MDButton
                                            color="singh"
                                            sx={{
                                              borderRadius: "2.5rem",
                                              minWidth: "100px",
                                            }}
                                            onClick={() =>
                                              handleAcceptBid(
                                                item.address,
                                                item.price,
                                                item._id,
                                                idx
                                              )
                                            }
                                          >
                                            {acceptBtnLoader[idx] ? (
                                              <CircularProgress
                                                size={20}
                                                color="inherit"
                                              />
                                            ) : (
                                              "Accept"
                                            )}
                                          </MDButton>
                                        </MDBox>
                                      ) : (
                                        item.username ===
                                          localStorage.getItem(
                                            "userNameSingh"
                                          ) && (
                                          <MDBox>
                                            <MDButton
                                              size="small"
                                              color="singh"
                                              sx={{
                                                borderRadius: "2.5rem",
                                                minWidth: "100px",
                                              }}
                                              onClick={() =>
                                                handleCancelBid(item._id, idx)
                                              }
                                            >
                                              {cancelBtnLoader[idx] ? (
                                                <CircularProgress
                                                  size={20}
                                                  color="inherit"
                                                />
                                              ) : (
                                                "Cancel"
                                              )}
                                            </MDButton>
                                          </MDBox>
                                        )
                                      )}
                                    </MDBox>
                                  ))}
                                </>
                              ) : (
                                <MDTypography
                                  sx={{
                                    textAlign: "center",
                                    marginTop: "40px",
                                    fontSize: "16px",
                                    color: "#cacaca",
                                  }}
                                >
                                  No bids received yet!
                                </MDTypography>
                              )}
                            </MDBox>
                          </List>
                        </AccordionDetails>
                      </Accordion>
                    )}

                    <Accordion
                      sx={{ backgroundColor: "#062330", padding: "8px 16px" }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        name="history"
                      >
                        <MDBox sx={{ display: "flex", alignItems: "center" }}>
                          <ListItemIcon>
                            <NfcIcon fontSize="medium" sx={{ color: "#fff" }} />
                          </ListItemIcon>
                          <MDTypography
                            sx={{ fontSize: "18px", fontWeight: "700" }}
                          >
                            History
                          </MDTypography>
                        </MDBox>
                      </AccordionSummary>
                      <AccordionDetails>
                        <MDBox>
                          <List sx={{ paddingLeft: "10px" }}>
                            <MDBox value={tabValue} index={2}>
                              {soldList.length > 0 ? (
                                <>
                                  {soldList.map((item, idx) => (
                                    <MDBox
                                      key={idx}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <MDBox
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <MDBox>
                                          <MDAvatar
                                            src={item.profilePic}
                                            imgProps={{
                                              style: {
                                                height: "100%",
                                                width: "100%",
                                              },
                                            }}
                                          />
                                        </MDBox>
                                        <MDBox>
                                          <MDTypography
                                            sx={{
                                              fontSize: "16px",
                                              marginLeft: "10px",
                                            }}
                                          >
                                            {item.price} SINGH by &nbsp;
                                            {`${item.address.substring(
                                              0,
                                              9
                                            )}...${item.address.substring(
                                              item.address.length - 5
                                            )}`}
                                          </MDTypography>
                                          <MDTypography
                                            sx={{
                                              fontSize: "14px",
                                              marginLeft: "10px",
                                              color: "#CACACA",
                                            }}
                                          >
                                            <Moment fromNow>{item.date}</Moment>
                                          </MDTypography>
                                        </MDBox>
                                      </MDBox>
                                    </MDBox>
                                  ))}
                                </>
                              ) : (
                                <MDTypography
                                  sx={{
                                    textAlign: "center",
                                    marginTop: "40px",
                                    fontSize: "16px",
                                    color: "#cacaca",
                                  }}
                                >
                                  No history yet!
                                </MDTypography>
                              )}
                            </MDBox>
                          </List>
                        </MDBox>
                      </AccordionDetails>
                    </Accordion>
                  </Card>
                </Grid>
              </Grid>
            </Card>
          </>
        )}
        {likeDialogBoolean && (
          <LikesDialog
            openStatus={likeDialogBoolean}
            onClose={() => handleCloseLikeDialog()}
            postId={postId}
          />
        )}
        {commentDialogBoolean && (
          <CommentsDialog
            openStatus={commentDialogBoolean}
            onClose={() => handleCloseCommentDialog()}
            postId={postId}
          />
        )}
        {mintDialogBoolean && (
          <MintDialog
            openStatus={mintDialogBoolean}
            onClose={() => handleCloseMintDialog()}
            mintData={mintNftData}
            priceChange={changePriceBoolean}
          />
        )}
      </MDBox>
    </DashboardLayout>
  );
}
